const implantology = {
  hero: {
    title: "IMPLANTOLOGIE",
    description:
      "Unsere Zahnarztpraxis bietet hochwertigen, langlebigen Zahnersatz, der ein natürliches Aussehen und Gefühl garantiert, sich perfekt in Ihre natürlichen Zähne einfügt und Ihre allgemeine Mundgesundheit erheblich verbessert.",
    ctas: {
      bookConsultation: "Beratungstermin buchen",
      learnMore: "Mehr erfahren",
    },
    imageAlt: "Fortschrittliche Zahnimplantate",
    successRate: {
      title: "98% Erfolgsquote",
      subtitle: "mit unseren fortschrittlichen Implantaten",
    },
  },
  benefits: {
    heading: "WARUM ZAHNIMPLANTATE WÄHLEN",
    intro:
      "Zahnimplantate bieten eine dauerhafte Lösung für fehlende Zähne mit Vorteilen, die über die Ästhetik hinausgehen.",
    items: [
      {
        title: "Natürliches Aussehen & Gefühl",
        description:
          "Implantate bieten die gleiche Stabilität und das gleiche Aussehen wie natürliche Zähne, sodass Sie mit Selbstvertrauen lächeln, sprechen und essen können.",
      },
      {
        title: "Erhalt der Knochengesundheit",
        description:
          "Im Gegensatz zu herkömmlichen Prothesen stimulieren Implantate das Knochenwachstum und verhindern den Knochenabbau, der bei fehlenden Zähnen auftritt.",
      },
      {
        title: "Langlebige Lösung",
        description:
          "Bei richtiger Pflege können Zahnimplantate ein Leben lang halten, was sie langfristig zu einer kostengünstigen Lösung macht.",
      },
    ],
  },
  process: {
    heading: "DER IMPLANTATIONS-PROZESS",
    intro:
      "Unser optimierter Prozess sorgt für minimale Beschwerden und maximale Ergebnisse.",
    steps: [
      {
        title: "Beratung & Planung",
        description:
          "Wir beginnen mit einer umfassenden Untersuchung unter Verwendung fortschrittlicher 3D-Bildgebung, um Ihre Mundgesundheit zu beurteilen und einen persönlichen Behandlungsplan zu erstellen.",
      },
      {
        title: "Implantatsetzung",
        description:
          "Unter Einsatz modernster Technologie setzen wir das Titanimplantat sorgfältig in den Kieferknochen ein, wo es als Wurzel für Ihren neuen Zahn dienen wird.",
      },
      {
        title: "Heilung & Integration",
        description:
          "Über einen Zeitraum von 3-6 Monaten verwächst das Implantat in einem Prozess namens Osseointegration mit Ihrem Kieferknochen und schafft so ein stabiles Fundament.",
      },
      {
        title: "Endgültige Versorgung",
        description:
          "Sobald die Heilung abgeschlossen ist, befestigen wir eine maßgefertigte Krone, die in Farbe, Form und Größe Ihren natürlichen Zähnen entspricht.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Erhalten Sie Antworten auf häufige Fragen zu Zahnimplantaten",
    items: [
      {
        question: "Sind Zahnimplantate schmerzhaft?",
        answer:
          "Die meisten Patienten berichten, dass der Eingriff weniger schmerzhaft ist als erwartet. Wir verwenden moderne Anästhesie- und Sedierungsmöglichkeiten, um Ihren Komfort während des gesamten Prozesses zu gewährleisten. Beschwerden nach dem Eingriff sind in der Regel mild und können mit rezeptfreien Schmerzmitteln behandelt werden.",
      },
      {
        question: "Wie lange halten Zahnimplantate?",
        answer:
          "Bei richtiger Pflege und Wartung können Zahnimplantate ein Leben lang halten. Die Krone muss möglicherweise nach 10-15 Jahren aufgrund normaler Abnutzung ersetzt werden, aber das Implantat selbst kann unbegrenzt in Ihrem Kieferknochen integriert bleiben.",
      },
      {
        question: "Bin ich ein guter Kandidat für Zahnimplantate?",
        answer:
          "Die meisten Erwachsenen mit gutem allgemeinem Gesundheitszustand sind Kandidaten für Zahnimplantate. Wichtige Faktoren sind eine ausreichende Knochendichte zur Unterstützung des Implantats und gesundes Zahnfleisch. Während Ihrer Beratung werden wir Ihre spezifische Situation bewerten und alle verfügbaren Optionen besprechen.",
      },
      {
        question: "Wie pflege ich meine Zahnimplantate?",
        answer:
          "Zahnimplantate erfordern die gleiche Pflege wie natürliche Zähne: regelmäßiges Zähneputzen, Verwendung von Zahnseide und zahnärztliche Kontrolluntersuchungen. Obwohl sie keine Karies entwickeln können, kann sich das umliegende Zahnfleischgewebe ohne angemessene Mundhygiene entzünden, daher ist die Aufrechterhaltung guter Mundgesundheitspraktiken unerlässlich.",
      },
    ],
    cta: "Vereinbaren Sie Ihren Beratungstermin",
  },
};

export default implantology;

